import { useCallback, useState } from 'react'

const useCloseConfirmationModal = ({ onHide, shouldShowCloseConfirmation }) => {
  const [showCloseConfirmationModal, setShowCloseConfirmationModal] = useState(false)

  const onHideOverride = useCallback(() => {
    if (shouldShowCloseConfirmation?.()) {
      setShowCloseConfirmationModal(true)
    } else {
      onHide()
    }
  }, [onHide, shouldShowCloseConfirmation])

  const hideCloseConfirmationModal = useCallback(() => setShowCloseConfirmationModal(false), [])

  return { showCloseConfirmationModal, hideCloseConfirmationModal, onHideOverride }
}

export default useCloseConfirmationModal
